import type { DataViewMode } from 'components/DataView';
import type { GetDeliveriesQuery } from 'data/__generated__';

import { DeliveriesDataTableView } from '../DeliveriesDataTableView';
import { DeliveriesTimelineView } from '../DeliveriesTimelineView';
import { DeliveriesTrelloView } from '../DeliveriesTrelloView';

export type DeliveryRow = GetDeliveriesQuery['deliveries'][number];

// Les trois vues ne se connaissent pas : elles reçoivent les lignes déjà filtrées et l'API de sélection,
// portées par la `DataView`. `render` est un champ de config, comme `ColumnDef.cell`.
export const DELIVERY_VIEWS: DataViewMode<DeliveryRow>[] = [
    {
        key: 'kanban',
        label: 'Kanban',
        render: ({ rows, selection }) => (
            <DeliveriesTrelloView
                deliveries={rows}
                selectedDeliveryIds={selection.selectedKeys}
                setSelectedDeliveryIds={selection.setSelectedKeys}
                toggleDeliverySelection={selection.toggleKey}
            />
        ),
    },
    {
        key: 'timeline',
        label: 'Timeline',
        render: ({ rows, selection }) => (
            <DeliveriesTimelineView
                deliveries={rows}
                selectedDeliveryIds={selection.selectedKeys}
                toggleDeliverySelection={selection.toggleKey}
            />
        ),
    },
    {
        key: 'table',
        label: 'Tableau',
        render: ({ rows, selection }) => (
            <DeliveriesDataTableView
                deliveries={rows}
                selectedDeliveryIds={selection.selectedKeys}
                setSelectedDeliveryIds={selection.setSelectedKeys}
            />
        ),
    },
];
